"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECT_BOOK = exports.DEFAULT_PATIENT_REL = exports.ESTABLISHED_PATIENT = exports.NEW_PATIENT = void 0;
exports.NEW_PATIENT = 'new';
exports.ESTABLISHED_PATIENT = 'established';
exports.DEFAULT_PATIENT_REL = exports.ESTABLISHED_PATIENT;
exports.DIRECT_BOOK = 'direct_book';
//# sourceMappingURL=Filters.js.map